class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-modal-toggle]');
    this.dialog = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('.search-modal__close-button');

    if (!this.toggleButton || !this.dialog || !this.closeButton) return;

    this.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.toggleButton.addEventListener('click', this.onToggleClick.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.dialog.hidden = true;
    
  }

  isOpen() {
    return !this.dialog.hidden;
  }

  onToggleClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.setAttribute('open', '');
    this.dialog.hidden = false;
    
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.dialog.querySelector('[tabindex="-1"]'),
      this.dialog.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.dialog || !this.toggleButton) return;
    removeTrapFocus(focusToggle ? this.toggleButton : null);
    this.dialog.hidden = true;
    this.removeAttribute('open');
    
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);